<i18n>
{
  "ru":{
    "session_timeout": "Завершение сессии через"
  },
  "en":{
    "session_timeout": "Session timeout"
  }
}
</i18n>

<template>
  <el-row type="flex" justify="center" align="middle">
    <el-col class="aligner right">
      <countdown v-if="left > 0" :time="left" :interval="1000" @countdownend="countdownend" tag="span" class="text_alert">
        <template slot-scope="props">
          <span class="text_alert_description">{{$t('session_timeout')}}:</span> {{ props.minutes }}:{{ props.seconds }}
        </template>
      </countdown>
      <el-select disabled v-model="$locale" :placeholder="$t('language')" size="mini" style="width: 80px">
        <el-option label="RU" value="ru"></el-option>
        <el-option label="EN" value="en"></el-option>
      </el-select>
    </el-col>
  </el-row>
</template>

<script>
import authSvc from './authSvc'

export default {
  name: 'system-info',
  data: () => ({
    title: '',
    left: null
  }),
  created () {
    this.left = Math.ceil((authSvc.expire - Date.now()))
    if (this.left <= 0) {
      this.logout()
    }
  },
  methods: {
    countdownend: function () {
      this.logout()
    },
    logout: function () {
      authSvc.logout()
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style>
@media screen and (max-width: 768px) {
  .text_alert_description {
    display: none;
  }
}
</style>
